import type { TransferFormData } from './types'

export const EMPTY_TRANSFER: TransferFormData = {
  name: '',
  iban: '',
  amount: '',
  reference: '',
}

export const TRANSFER_CURRENCY = 'EUR'

export const NAME_MAX_LENGTH = 70
export const IBAN_MAX_LENGTH = 34
export const REFERENCE_MAX_LENGTH = 135
export const PIN_LENGTH = 4
export const OTP_LENGTH = 6
